<div class="header-bar">
  <h1>Home</h1>
</div>
<div class="content-container">
  <div class="card card-w-title">
    <div class="ui-g">
      <div class="ui-g-12">
        <h2 class="sub-header-bar">Job Volumes</h2>
        <div class="ui-g ui-g-12">
          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-1">
              <div class="ui-g-2"><i class="vme-material-icons">&#xe90b;</i></div>
              <div class="ui-g-7">
                <a (click)="goToInbox($event, inboxType_SupplierToBeConfirmed)"
                  >Supplier To Be Confirmed</a
                >
              </div>
              <div class="ui-g-3 param-value">{{ data.supplierToBeConfirmed }}</div>
            </div>
          </div>
          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-2">
              <div class="ui-g-2"><i class="vme-material-icons">&#xe909;</i></div>
              <div class="ui-g-7">
                <a (click)="goToInbox($event, inboxType_SupplierToBeConfirmed, stageHeld)"
                  >Hold Stage</a
                >
              </div>
              <div class="ui-g-3 param-value">{{ data.holdStage }}</div>
            </div>
          </div>

          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-4">
              <div class="ui-g-2"><i class="vme-material-icons">&#xe81e;</i></div>
              <div class="ui-g-7">
                <a (click)="goToInbox($event, inboxType_SupplierToBeConfirmed, stageBuyNow)"
                  >Buy It Now</a
                >
              </div>
              <div class="ui-g-3 param-value">{{ data.buyItNow }}</div>
            </div>
          </div>

          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-4">
              <div class="ui-g-2"><i class="vme-material-icons">&#xe90c;</i></div>
              <div class="ui-g-7">
                <a (click)="goToInbox($event, inboxType_AwaitingStart)">Awaiting Start</a>
              </div>
              <div class="ui-g-3 param-value">{{ data.awaitingStart }}</div>
            </div>
          </div>

          <div class="ui-lg-3 ui-g-4 ui-sm-12">
            <div class="job-volumes param-4">
              <div class="ui-g-2"><i class="vme-material-icons">&#xe913;</i></div>
              <div class="ui-g-7">
                <a (click)="goToInbox($event, inboxType_Live)">Live Now</a>
              </div>
              <div class="ui-g-3 param-value">{{ data.liveJobs }}</div>
            </div>
          </div>

          <div class="ui-lg-3 ui-md-4 ui-sm-12">
            <div class="job-volumes param-4">
              <div class="ui-g-2"><i class="vme-material-icons">&#xe90a;</i></div>
              <div class="ui-g-7">
                <a (click)="goToInbox($event, inboxType_JobsWaitingForApproval)"
                  >Waiting For Approval</a
                >
              </div>
              <div class="ui-g-3 param-value">{{ data.waitingForApproval }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="ui-g-6 ui-sm-12">
        <h1>Order/Job Location Map</h1>

        <div class="ui-g-12">
          <p-inputSwitch [(ngModel)]="isOfflineMode"></p-inputSwitch>
          <span *ngIf="!isOfflineMode">Driver Live View</span>
          <span *ngIf="isOfflineMode">Job Live View</span>
        </div>

        <map-control
          *ngIf="!isOfflineMode"
          [tasks]="tasksLive"
          [readOnly]="true"
          (selectedTaskChange)="taskClick($event)"
          [customStyle]="{ height: 'calc(100% - (70px))' }"
        ></map-control>

        <map-control
          *ngIf="isOfflineMode"
          [tasks]="tasksOffline"
          [readOnly]="true"
          (selectedTaskChange)="taskClick($event)"
          [customStyle]="{ height: 'calc(100% - (70px))' }"
        ></map-control>
      </div>

      <div class="ui-g-6 ui-sm-12">
        <div class="ui-g-12" *ngIf="false">
          <h1>Driver Status</h1>

          <div class="ui-g">
            <div class="ui-g-4 ui-sm-12">
              <div class="driver-status">
                <div class="ui-g-8">Start Movement</div>
                <div class="ui-g-4 param-value">{{ data.startMovement }}</div>
              </div>
            </div>
            <div class="ui-g-4 ui-sm-12">
              <div class="driver-status">
                <div class="ui-g-8">End Movement</div>
                <div class="ui-g-4 param-value">{{ data.endMovement }}</div>
              </div>
            </div>
            <div class="ui-g-4 ui-sm-12">
              <div class="driver-status">
                <div class="ui-g-8">Complete Jobs</div>
                <div class="ui-g-4 param-value">{{ data.completeJob }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="ui-g-12">
          <h1>Jobs Starting By Hour Band</h1>

          <p-chart
            type="bar"
            [data]="unallocatedOrders"
            [options]="unallocatedOrdersOptions"
          ></p-chart>
        </div>

        <div class="ui-g-12">
          <h1>OnBoarding Requests</h1>

          <p-chart
            type="bar"
            [data]="onboarding"
            [options]="onboardingOptions"
            (onDataSelect)="selectData($event)"
          ></p-chart>
        </div>
      </div>
    </div>
  </div>
</div>
